<template>
  <v-flex
    mb-2
  >
    <div
      style="height:400px;overflow-y: scroll;"
    >
      <p
        align="justify"
        v-html="usperson"
      />
      <p
        align="justify"
        v-html="terms"
      />
      <p
        align="justify"
        v-html="risks"
      />
      <p
        align="justify"
        v-html="affs"
      />
    </div>
    <v-checkbox
      v-model="checked"
      class="mt-3 mb-3"
      color="primary"
    >
      <template v-slot:label>
        <small>
          <b>{{ $t('terms.acceptCheckbox') }}</b>
          <p
            v-if="error != null"
            class="text-danger"
          >
            <small>{{ $t("profile.pleaseAcceptTerms") }}</small>
          </p>
        </small>
      </template>
    </v-checkbox>
    <center>
      <v-btn
        class="primary"
        large
        @click="Accept()"
      >
        {{ $t('profile.continueButton') }}
      </v-btn>
    </center>
  </v-flex>
</template>

<script>

export default {
  name: "AcceptTerms",
  data: () => ({
    checked: false,
    error: null
  }),
  computed: {
    usperson() {
      return this.$t("terms.usPersons").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    terms() {
      return this.$t("terms.acceptTerms").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    risks() {
      return this.$t("terms.acceptRisks").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    affs() {
      return this.$t("terms.acceptAffs").replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
  },
  methods: {
    Accept() {
      if (this.checked) {
        gtag('event', 'Terms Accepted', {
          'event_category': 'Package Sales',
          'event_label': 'Packages Form',
        });
        this.$emit('acceptTerms', this.checked)
        return
      }
      this.error = this.$t("profile.pleaseAcceptTerms");
    }
  }
};
</script>

<style lang="scss">

</style>
